module.exports = __webpack_public_path__ + "media/images/lig/shirt-carousel/shirt-05-8066ef4b195dc7dbab711eb42d5707e4.jpg";